export const removeUndefinedSearchParams = <T extends Record<string, unknown>>(
  search: T
): T =>
  Object.fromEntries(
    Object.entries(search).filter(([, value]) => value !== undefined)
  ) as T;
